import React, { Suspense, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Loading from "./Components/Loading";
import CreditProfiling from "./Components/Products/CreditProfiling";
import WhyMywagepay from "./Components/WhyMywagepay";
import News from "./Components/News/News";
import Otp from "./Investor_hub/Auth/Otp";
import { profileContext, tierContext } from "./Helper/Context";
import ProtectedRoute from "./Storage/protectedRoute";
const PrivacyPolicy = React.lazy(() => import("./Components/PrivacyPolicy"));
const Capital = React.lazy(() => import("./Components/Products/Capital"));
const Embedded = React.lazy(() => import("./Components/Products/Embedded"));
const NewsDets = React.lazy(() => import("./Components/News/NewsDetails"));
const Home = React.lazy(() => import("./Components/LandingPage/Home"));
const Accounts = React.lazy(() => import("./Components/Accounts"));
const Register = React.lazy(() => import("./Components/Register"));
const Faq = React.lazy(() => import("./Components/Faq"));
const Aboutus = React.lazy(() => import("./Components/Aboutus"));
const Blogpage = React.lazy(() => import("./Components/Blog/Blogpage"));
const BlogView = React.lazy(() => import("./Components/Blog/Blogview"));
const Terms = React.lazy(() => import("./Components/Terms"));
const Footer = React.lazy(() => import("./Components/Footer"));
const Careers = React.lazy(() => import("./Components/Careers"));
const Invest = React.lazy(() => import("./Components/Invest"));
const Login = React.lazy(() => import("./Investor_hub/Auth/Login"));
const Signup = React.lazy(() => import("./Investor_hub/Auth/Signup"));
const Dashboard = React.lazy(() => import("./Investor_hub/MainPage"));
const Investment = React.lazy(() => import("./Investor_hub/MyInvestment"));
const Profile = React.lazy(() => import("./Investor_hub/Profile"));
const AdminDashboard = React.lazy(() => import("./Investor_Admin/MainPage"));

function AppContent() {
  const location = useLocation();

  const hideFooterRoutes = [
    "/login",
    "/signup",
    "/loading",
    "/overview",
    "/investment",
    "/profile",
    "/otp",
    "/dashboard",
  ];

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/Accounts" element={<Accounts />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/otp" element={<Otp />} />

        {/* Investor Route  */}
        <Route element={<ProtectedRoute allowedRoles={["investor"]} />}>
          <Route path="/profile" element={<Profile />} />
          <Route path="/overview" element={<Dashboard />} />
          <Route path="/investment" element={<Investment />} />
        </Route>

        {/* Admin Route */}
        <Route element={<ProtectedRoute allowedRoles={["admin"]} />}>
          <Route path="/dashboard" element={<AdminDashboard />} />
        </Route>

        {/* Website routes */}
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/profiling" element={<Capital />} />
        <Route path="/embed" element={<Embedded />} />
        <Route path="/capital" element={<CreditProfiling />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/invest" element={<Invest />} />
        <Route path="/news" element={<News />} />
        <Route path="/loading" element={<Loading />} />
        <Route path="/blog" element={<Blogpage />} />
        <Route path="/blogview/:slug/:category" element={<BlogView />} />
        <Route path="/termsandconditions" element={<Terms />} />
        <Route path="newspost/:slug" element={<NewsDets />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/whymywagepay" element={<WhyMywagepay />} />
        <Route path="/Careers" element={<Careers />} />
      </Routes>
      {!hideFooterRoutes.includes(location.pathname) && <Footer />}
    </Suspense>
  );
}

function App() {
  const [investor, setInvestor] = useState(null);
  const [plans, setPlans] = useState([]);

  return (
    <profileContext.Provider value={{ investor, setInvestor }}>
      <tierContext.Provider value={{ plans, setPlans }}>
        <Router>
          <AppContent />
        </Router>
      </tierContext.Provider>
    </profileContext.Provider>
  );
}

export default App;
